import { useContext } from 'react';
import Modalv2 from '../../Components/Modalv2';
import SiteConfig from './Components/SiteConfig';
import BatchedAdRequestsConfig from './Components/RequestStructureData/BatchedAdRequests';
import UnmuteAfterInteractionConfig from './Components/FeaturesData/unmuteAfterInteractionConfig';
import UamConfigSettings from './Components/NetworkData/UamConfig';
import CreateVideoSectionUI from './Components/UnitCreatorUi';
import NetworkDataGeneralSettings from './Components/NetworkData/GeneralSettings';
import AdUnitAndVastManager from './Components/AdUnitAndVastManager';
import DemandSequenceConfig from './Components/NetworkData/DemandSequence';
import FvpConfigOverview from './Components/OverviewConfig';
import { FvpConfigContext } from '../../Contexts/FvpConfigContext';
import VideoSectionSettings from './Components/VideoSectionSettings';
import FinalOverview from './Components/FinalOverview';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
import GeneralButton from '../../Components/GeneralButton';
import { Typography } from '@mui/material';
import { Modalv2Context } from '../../Contexts/Modalv2Context';
import ConfigEditorMainPage from '../../Components/ConfigEditorMainPage';

//mui sidebar icons import
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import FilterDramaOutlinedIcon from '@mui/icons-material/FilterDramaOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import FeaturedPlayListOutlinedIcon from '@mui/icons-material/FeaturedPlayListOutlined';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import AdUnitsIcon from '@mui/icons-material/AdUnits';

const FvpConfigGenerator = () => {
	const { curSelectedId } = useContext(FvpConfigContext);
	const { updateModalContent } = useContext(Modalv2Context);

	const settingConfigs = {
		siteSettings: <SiteConfig />,
		videoSectionSettings: <VideoSectionSettings />,
		batchedAdRequests: <BatchedAdRequestsConfig keyData={'requestStructureData'} />,
		unmuteAfterInteractionConfig: (
			<UnmuteAfterInteractionConfig keyData="featuresData.unmuteAfterInteractionConfig" />
		),
		networkDataGeneralSettings: <NetworkDataGeneralSettings keyData={'networkData'} />,
		adUnitAndVastManager: <AdUnitAndVastManager keyData="networkData.adUnitAndVastManager" />,
		uamConfig: <UamConfigSettings keyData="networkData.uamConfig" />,
		demandSequence: <DemandSequenceConfig keyData={'networkData.demandSequence'} />,
		finalOverview: <FvpConfigOverview />
	};

	const sidebarConfig = [
		{
			icon: <LanguageOutlinedIcon fontSize="medium" />,
			label: 'Site Settings',
			settingName: 'siteSettings'
		},
		{
			icon: <VideoLibraryOutlinedIcon fontSize="medium" />,
			label: 'Video Section',
			settingName: 'videoSectionSettings'
		},
		{
			icon: <AdUnitsIcon fontSize="medium" />,
			label: 'Ad Units and Vast Manager',
			settingName: 'adUnitAndVastManager'
		},
		{
			icon: <DnsOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Request Structure',
			name: 'REQUEST_STRUCTURE_DATA_ACCORDION',
			settings: [
				{
					label: 'Batched Ad Requests',
					settingName: 'batchedAdRequests'
				}
			]
		},
		{
			icon: <FeaturedPlayListOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Features Data',
			name: 'FEATURES_DATA_ACCORDION',
			settings: [
				{
					label: 'UAI',
					settingName: 'unmuteAfterInteractionConfig'
				}
			]
		},
		{
			icon: <FilterDramaOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Network Data',
			name: 'NETWORK_DATA_ACCORDION',
			settings: [
				{
					label: 'General Settings',
					settingName: 'networkDataGeneralSettings'
				},
				{
					label: 'UAM Config',
					settingName: 'uamConfig'
				},
				{
					label: 'Demand Sequence',
					settingName: 'demandSequence'
				}
			]
		},
		{
			icon: <FindInPageOutlinedIcon fontSize="medium" />,
			label: 'Section Overview',
			settingName: 'finalOverview'
		},
		{
			isButton: true,
			button: (
				<GeneralButton
					system={ACCESS_CONTROL_CONSTANTS.SYSTEMS.FVP_PLAYER}
					name={'FINAL_OVERVIEW_BUTTON'}
					color="secondary"
					variant="contained"
					size="large"
					onClick={() => {
						updateModalContent(<FinalOverview />);
					}}
				>
					<Typography fontWeight="bold">Final Overview</Typography>
				</GeneralButton>
			)
		}
	];

	return (
		<>
			<ConfigEditorMainPage
				sidebarConfig={sidebarConfig}
				settingConfigs={settingConfigs}
				isLoading={!curSelectedId}
				system={ACCESS_CONTROL_CONSTANTS.SYSTEMS.FVP_PLAYER}
			/>
			<CreateVideoSectionUI />
			<Modalv2 />
		</>
	);
};
export default FvpConfigGenerator;
